import { AxiosResponse } from "axios";
import axios, { APIWrapperResponse, DefaultResponse, TypedResponse } from "../general/HttpClient";

export function getStats() {
    return axios.get("/api/stats/getStats", {}).then((response: AxiosResponse<APIWrapperResponse<TypedResponse<Array<StatViewModel>>>>) => {
        return response.data.result;
    });
}

export function getStat(id) {
    return axios.get(`/api/stats/getStat/${id}`).then((response: AxiosResponse<APIWrapperResponse<TypedResponse<StatViewModel>>>) => {
        return response.data.result;
    });
}

export function createStat(request: CreateStatRequest) {
    return axios.post(`/api/stats/createStat`, request).then((response: AxiosResponse<APIWrapperResponse<TypedResponse<StatViewModel>>>) => {
        return response.data.result;
    });
}

export function updateStat(request: UpdateStatRequest) {
    return axios.post(`/api/stats/updateStat`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export class StatViewModel {
    id?: string;
    name: string;
    description: string;
    type: string;
    color: string;
    icon: string;
    invertedScoring: boolean;
}
export class CreateStatRequest {
    name: string;
    description: string;
    type: string;
    color: string;
    icon: string;
    invertedScoring: boolean;
}

export class UpdateStatRequest {
    id: string;
    name: string;
    description: string;
    type: string;
    color: string;
    icon: string;
}

export interface StatType {
    name: string;
    value: number;
    displayName: string;
}
